<template>
  <el-dialog
    v-model="dialogVisible"
    :dangerously-use-html-string="true"
    :width="dialogWidth"
    :show-close="false"
    :before-close="close"
    align-center
    >
    <template #header>
      <div class="header">{{ dialogState?.title }}</div>
    </template>
    <template #default>
      <div class="content" v-html="dialogState?.message"></div>
    </template>
    <template #footer>
      <el-button @click="close">閉じる</el-button>
    </template>
  </el-dialog>
</template>

<script lang="ts" setup>
const { dialogState, close } = useDialog();

const dialogVisible = computed<boolean>(() => dialogState.value !== null);
const dialogWidth   = computed<string>(() => useDeviceCheck().isLargeScreen.value ? '50%' : '90%');
</script>
